import React from 'react'
import {
  Datagrid,
  ArrayField,
  FileField,
  SimpleShowLayout,
  TextField,
  DateField,
  RichTextField,
  ReferenceField
} from 'react-admin'
import FileSizeField from '../../components/FileSizeField'
import Title from '../../components/Title'
import ClearFix from '../../components/ClearFix'
import BooleanField from '../../components/BooleanField'
import RecordShowActions from '../../components/RecordShowActions'
import Show from '../../components/Show'

export default props => {
  return (
    <Show title={<Title />} actions={<RecordShowActions />} {...props}>
      <SimpleShowLayout>
        <TextField
          className='col-xs-12 col-sm-6 col-md-5 col-lg-4 col-fix'
          source='attributes.title'
        />
        <DateField
          className='col-xs-12 col-sm-6 col-md-5 col-lg-4 col-fix'
          source='attributes.field_date'
        />
        <ClearFix className='clearfix' />

        <ReferenceField
          className='col-xs-12 col-sm-6 col-md-5 col-lg-4 col-fix'
          source='relationships.field_firm.data.id'
          reference='node/firm'
        >
          <TextField source='attributes.title' />
        </ReferenceField>

        <BooleanField
          className='col-xs-12 col-sm-6 col-md-5 col-lg-4 col-fix'
          source='attributes.field_active'
        />

        <ClearFix className='clearfix' />

        <ArrayField className='col-xs-12' source='included.field_files'>
          <Datagrid>
            <FileField
              source='attributes.uri.url'
              title='attributes.filename'
              target='_blank'
            />
            <FileSizeField source='attributes.filesize' />
          </Datagrid>
        </ArrayField>
        <RichTextField className='col-xs-12' source='attributes.body.value' />
      </SimpleShowLayout>
    </Show>
  )
}
